import request from '@/utils/infrastructure/communication/request';

export async function queryGetEnvironmentsConfig(payload) {
  return request(`/user/environments/${payload.userId}`, {
    params: payload.params,
  });
}

export async function queryAddEnviroments(info) {
  return request.post(`/user/updateEnvironments/${info.idSelected}`, {
    data: info.data,
  });
}

export async function queryUserGroupUsers(payload) {
  return request(`/user/groups/${payload.userId}`, {
    params: payload.params,
  });
}

export async function queryUserActivate(id, state) {
  return request.post(`/user/activate/${id}/${state}`, {});
}

export async function queryBulkAction(bulkActionType, userIds) {
  return request.post(`/user/bulkAction/${bulkActionType}`, {
    data: userIds,
  });
}

export async function queryBulkTwoFactor(state, userIds) {
  return request.post(`/user/twoFactor/${state}`, {
    data: userIds,
  });
}

export async function queryAddUserGroupUser(payload) {
  return request.post(`/user/updateGroups/${payload.id}`, {
    data: payload.data,
  });
}

export async function querySendAccountConfirmationEmail(id) {
  return request.post(`/user/sendConfirmAccountEmail/${id}`, {});
}

export async function queryConfirmAccount(id) {
  return request.post(`/user/confirmAccount/${id}`, {});
}

export async function querySendRecoveryPasswordEmail(id) {
  return request.post(`/user/sendRecoveryPasswordEmail/${id}`, {});
}

export async function queryUnlockAccount(id) {
  return request.post(`/user/unlockAccount/${id}`, {});
}

export async function querySetDefaultUser(userId) {
  return request.post(`/user/default/${userId}`, {});
}

export async function queryResetPassword(payload) {
  return request.post(`/user/resetPassword/${payload.id}`, {
    data: payload.data,
  });
}

export async function queryChangeUserEmail(payload) {
  return request.post(`/user/changeEmail/${payload.id}`, {
    data: { email: payload.email },
  });
}

export async function queryRestoreUser(userIds) {
  return request.post('/user/restore', {
    data: Array.isArray(userIds) ? userIds : [userIds],
  });
}

export async function queryRestoreAndUpdateUsers(users) {
  return request.post('/user/restoreAndUpdate', {
    data: Array.isArray(users) ? users : [users],
  });
}
